import React from 'react';
import PropTypes from 'prop-types';

export default function ClearCircle(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.width} height={props.width} stroke={props.color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
  );
}

ClearCircle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

ClearCircle.defaultProps = {
  color: '#202020',
  width: 20,
};